import React, {useContext, useState} from 'react';
import './Email.less';
import {Button} from "elements/button/Button";
import {Input} from "elements/input/Input";
import {DrawerPopup} from "dialog-layout/drawer-popup/DrawerPopup.tsx";
import {Error} from 'elements/error/Error';
import {TranslationsContext} from "contexts/translations-context";
import {getSafeTranslation} from "helpers/localization.helper.ts";

export const EMAIL_POPUP = 'EMAIL_POPUP';

export const Email = ({defaultValue = '', error, onCancelClick, onDoneClick, onOverlayClick}) => {
	const [email, setEmail] = useState(defaultValue);

	const translations = useContext(TranslationsContext);

	return <DrawerPopup
		title={getSafeTranslation('EmailPopup.title', translations)}
		onOverlayClick={onOverlayClick}
		leftControl={<Button isText onClick={onCancelClick}>{
			getSafeTranslation('EmailPopup.cancelButtonCaption', translations)
		}</Button>}
		rightControl={<Button isAutoWidth onClick={() => onDoneClick(email)}>{
			getSafeTranslation('EmailPopup.doneButtonCaption', translations)
		}</Button>}
	>
		<div className="email">
			<div className="email__input">
				<Input value={email} onChange={setEmail} focusOnMount/>
			</div>
			{
				error && (<div className="email__error">
					<Error text={error}/>
				</div>)
			}

		</div>
	</DrawerPopup>
}
